var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V33.25",
    stroke: "#4FACE9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.284 29.1175C33.8283 28.2756 35.0482 26.9434 35.7513 25.3312C36.4543 23.7189 36.6005 21.9185 36.1666 20.2139C35.7328 18.5094 34.7437 16.9979 33.3554 15.918C31.9671 14.838 30.2587 14.2512 28.4998 14.25H26.5048C26.0256 12.3963 25.1323 10.6754 23.8922 9.21659C22.6521 7.7578 21.0975 6.59911 19.3451 5.82764C17.5928 5.05618 15.6884 4.692 13.775 4.7625C11.8616 4.83299 9.98917 5.33632 8.29834 6.23465C6.60752 7.13298 5.14234 8.40293 4.01297 9.94902C2.88359 11.4951 2.11941 13.2771 1.77787 15.1611C1.43633 17.045 1.52631 18.9819 2.04107 20.826C2.55582 22.6702 3.48195 24.3736 4.74982 25.8083",
    stroke: "#4FACE9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 25.3333L18.9998 19L12.6665 25.3333",
    stroke: "#4FACE9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlue);
export default __webpack_public_path__ + "static/media/UploadIconBlue.1e3c7913551af1dc8bf4983845f59314.svg";
export { ForwardRef as ReactComponent };